// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.d3a3452e09527271.css"
export const articleStylesHref = "/styles/article-critical.3fee0aa199f15919.css"
export const productStylesHref = "/styles/product-critical.bdb5c9b51ecd1214.css"
export const compareStylesHref = "/styles/compare-critical.d0f0da5dd3fdc0a8.css"
export const hubStylesHref = "/styles/hub-critical.f40b9e10dfe1a209.css"
export const brandStylesHref = "/styles/brand-critical.8d71c957a2f56105.css"
